import { useState } from "react";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet";
import { QRCodeCanvas } from "qrcode.react";
import "./signup.css";

const Signup = (props) => {
  const [platform, setPlatform] = useState("android");
  return (
    <div className="signup-container1">
      <Helmet>
        <title>
          Sign Up | CashOver Pay | Create Your Personal, Merchant or Business
          Account
        </title>
        <meta
          name="description"
          content="Join CashOver today. Create a personal, merchant, or business account to send, receive, deposit, or withdraw money securely — anytime, anywhere."
        />
        <meta
          property="og:title"
          content="Sign Up | CashOver | Create Your Personal, Merchant or Business Account"
        />
        <meta
          property="og:description"
          content="Join CashOver today. Create a personal, merchant, or business account to send, receive, deposit, or withdraw money securely — anytime, anywhere."
        />
        <meta
          property="og:image"
          content={`${process.env.REACT_APP_SITE_URL}/hero.webp`}
        />
      </Helmet>

      <div className="signup-bar">
        <Link to="/" className="signup-navlink1">
          <div className="signup-row1">
            <img
              alt="CashOver Logo"
              src="/icon.webp"
              className="signup-image1"
            />
            <div className="signup-column">
              <span className="signup-text10">CASHOVER</span>
              <span className="signup-text11">by overlab.io</span>
            </div>
          </div>
        </Link>
        <a
          href={process.env.REACT_APP_AGENT_URL}
          target="_blank"
          rel="noreferrer noopener"
          className="signup-action2 thq-button-outline-dark"
        >
          <span className="signup-text12">Agent Portal</span>
          <svg viewBox="0 0 1024 1024" className="signup-icon1">
            <path d="M298.667 341.333h323.669l-353.835 353.835c-16.683 16.683-16.683 43.691 0 60.331s43.691 16.683 60.331 0l353.835-353.835v323.669c0 23.552 19.115 42.667 42.667 42.667s42.667-19.115 42.667-42.667v-426.667c0-5.803-1.152-11.307-3.243-16.341s-5.163-9.728-9.216-13.781c-0.043-0.043-0.043-0.043-0.085-0.085-3.925-3.925-8.619-7.083-13.781-9.216-5.035-2.091-10.539-3.243-16.341-3.243h-426.667c-23.552 0-42.667 19.115-42.667 42.667s19.115 42.667 42.667 42.667z"></path>
          </svg>
        </a>
      </div>
      <div className="signup-container2">
        <div className="signup-choices">
          <a
            href={process.env.REACT_APP_MERCHANT_URL}
            target="_blank"
            rel="noreferrer noopener"
            className="signup-link1"
          >
            <label className="signup-text13">MERCHANT</label>
          </a>
          <label className="signup-text14">PERSONAL</label>
          <a
            href={process.env.REACT_APP_BUSINESS_URL}
            target="_blank"
            rel="noreferrer noopener"
            className="signup-link2"
          >
            <label className="signup-text15">BUSINESS</label>
          </a>
        </div>
        <div className="signup-box">
          <Link to="/" className="signup-navlink2">
            <img alt="image" src="/icon.webp" className="signup-image2" />
          </Link>
          <h2 className="signup-text16">
            <span>Create a personal account or login using our app.</span>
            <br></br>
            <span>Scan to Download CashOver Pay!</span>
          </h2>

          <QRCodeCanvas
            size={150}
            level={"H"}
            bgColor="transparent"
            fgColor="white"
            imageSettings={{
              excavate: true,
              src: "/icon.webp",
              height: 40,
              width: 40,
            }}
            value={
              platform === "android"
                ? process.env.REACT_APP_PERSONAL_ANDROID_URL
                :process.env.REACT_APP_PERSONAL_IOS_URL
            }
            className="signup-image3"
          />
          <div className="signup-platform-toggle">
            <button
              className={`signup-toggle-btn ${
                platform === "android" ? "active" : ""
              }`}
              onClick={() => setPlatform("android")}
            >
              Android
            </button>
            <button
              className={`signup-toggle-btn ${
                platform === "ios" ? "active" : ""
              }`}
              onClick={() => setPlatform("ios")}
            >
              iOS
            </button>
          </div>

          <div className="signup-row2">
            <div className="signup-divider1"></div>
            <span className="signup-text20">or</span>
            <div className="signup-divider2"></div>
          </div>
          <div className="signup-stores">
            <a
              href={process.env.REACT_APP_PERSONAL_ANDROID_URL}
              target="_blank"
              rel="noreferrer noopener"
              className="signup-link3"
            >
              <img
                alt="image"
                src="/play-badge.webp"
                className="signup-image4"
              />
            </a>
            <a
              href={process.env.REACT_APP_PERSONAL_IOS_URL}
              target="_blank"
              rel="noreferrer noopener"
              className="signup-link4"
            >
              <img
                alt="image"
                src="/apple-badge.webp"
                className="signup-image5"
              />
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Signup;
